import React, { useContext, useEffect, useState } from "react";
import { useAuthContext } from "../../../contexts/AuthContext";
import {
  greenColor,
  redColor,
  yellowColor,
  grayBorderColor,
} from "../DMCharts";
import {
  getCompletedDirAccRw,
  getLastVPContactTable,
  getCompletedDARCS,
  getCompletedVPCS,
  getCallPrepsCS,
  getCompletedSAICS,
  getConnectionPPC,
  getConnectionSEO,
  getConnectionSM,
  getConnectionSP,
  getOnboardingCT,
  getWelcomeCT,
} from "../../SF";
import ErrorMessage from "../ErrorMessage";
import Loader from "../Loader";
import Sidebar from "../Sidebar";
import { getStorageValue, getUrlParameter } from "../../Utils";

const AccountTable = () => {
  const context = useAuthContext();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [total, setTotal] = useState(null);

  useEffect(() => {
    if (!context || !context.userInfo) return;
    const fields = getUrlParameter("fields").split("_");
    if (getStorageValue("gargle_analytics_csc_id"))
      context.CSCId = getStorageValue("gargle_analytics_csc_id");
    if (getStorageValue("gargle_analytics_vp_id"))
      context.VPId = getStorageValue("gargle_analytics_vp_id");
    if (getStorageValue("gargle_analytics_owner_id"))
      context.OwnerId = getStorageValue("gargle_analytics_owner_id");
    const refresh = (load) => {
      if (context.accessToken !== null && load && !context.isLoading) {
        context.isLoading = true;
        getCompletedDirAccRw(context).then(function (result) {
          refreshData(result[fields[0]]);
        });
      }
    };
    const refreshData = (result) => {
      if (result === null) setError(true);
      else {
        setData(result);
        setTotal(
          (result.Green ? result.Green.length : 0) +
            (result.Gray ? result.Gray.length : 0) +
            (result.Red ? result.Red.length : 0) +
            (result.Yellow ? result.Yellow.length : 0)
        );
        setError(false);
      }
    };
    refresh(!data);
  }, [context, data]);

  if (!context || !context.userInfo) return null;

  const fields = getUrlParameter("fields").split("_");
  const fieldNames = getUrlParameter("fieldnames").split("_");
  const returnTo = getUrlParameter("returnto");

  const colWidth = 100 / (fields.length + 1) + "%";

  const addRow = (item, cls, key) => {
    const backColor =
      cls === "red"
        ? redColor
        : cls === "yellow"
        ? yellowColor
        : cls === "gray"
        ? grayBorderColor
        : greenColor;
    return (
      <div className="report-row" key={key} style={{ background: backColor }}>
        <div className="report-col" style={{ width: colWidth }}>
          <a
            href={"https://gargleinc.lightning.force.com/" + item.Id}
            target="_blank"
            rel="noopener noreferrer"
          >
            {item.Name}
          </a>
        </div>
        {fields.map((field, index) => {
          console.log(item.OrderId);
          return (
            <>
              {field !== "OrderLabel" && (
                <div
                  className="report-col"
                  style={{ width: colWidth }}
                  key={"col-" + index + "-" + key}
                >
                  {item[field]}
                </div>
              )}
              {field === "OrderLabel" && (
                <div
                  className="report-col"
                  style={{ width: colWidth }}
                  key={"col-" + index + "-" + key}
                >
                  <a
                    href={
                      "https://gargleinc.lightning.force.com/" + item.OrderId
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.OrderLabel}
                  </a>
                </div>
              )}
            </>
          );
        })}
      </div>
    );
  };

  window["bodyScroll"]();

  return (
    <>
      {error && <ErrorMessage />}
      {!error && (
        <>
          <Sidebar />
          <div className="content dashboard" style={{ padding: "40px" }}>
            {!data && <Loader />}
            {data && (
              <>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    window.location.href = returnTo;
                  }}
                  style={{ marginTop: "10px" }}
                >
                  Back to Dashboard
                </button>
                <button
                  className="btn-refresh"
                  onClick={() => window.location.reload()}
                  style={{ float: "right", marginTop: "10px" }}
                >
                  Refresh
                </button>
                <div className="report-table">
                  <div
                    className="report-col report-header"
                    style={{ width: colWidth }}
                  >
                    Name
                  </div>
                  {fieldNames.map((item, index) => {
                    return (
                      <div
                        className="report-col report-header"
                        style={{ width: colWidth }}
                        key={"header-" + index}
                      >
                        {item}
                      </div>
                    );
                  })}
                  {data.Red &&
                    data.Red.map((item, index) => {
                      return addRow(item, "red", index + "red");
                    })}
                  {data.Yellow &&
                    data.Yellow.map((item, index) => {
                      return addRow(item, "yellow", index + "yellow");
                    })}
                  {data.Green &&
                    data.Green.map((item, index) => {
                      return addRow(item, "green", index + "red");
                    })}
                  {data.Gray &&
                    data.Gray.map((item, index) => {
                      return addRow(item, "gray", index + "gray");
                    })}
                  <div
                    style={{
                      width: "100%",
                      display: "block",
                      padding: "10px",
                      textAlign: "right",
                      fontWeight: "bold",
                    }}
                  >
                    Total Number of Records: {total}
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default AccountTable;
